export const checkedOptions = (options) => {
  const result = [];

  Object.keys(options || {})?.forEach((item) => {
    if (options?.[item]?.checked) {
      result.push(item);
    }
  });

  return result;
};

export const optionsMiddleButton = {
  title: "Skip Demo",
  subTitle: "Go to Full migration step",
};

export const CLEAR_TARGET_KEY = "MIGRATION_OPTION_USER_CLEAR_TARGET";
export const ALL_OPTIONS_KEY = "MIGRATION_OPTION_USER_ALL_OPTIONS";

export const isAllowedInSelection = (item) => {
  if (!item?.disabled) {
    return true;
  }

  if (item?.inactive) {
    return true;
  }

  if (item?.pluginDisabled) {
    return false;
  }

  return Boolean(item?.checked);
};

export const getAllOptionsPackageRequiredOptions = (packageOptionKeys, items) =>
  packageOptionKeys?.filter((optionKey) => {
    const item = items?.find((option) => option.key === optionKey);
    return Boolean(item && !item.inactive && !item.disabled);
  }) || [];

export const createAllOptionsPackageItem = ({
  percent,
  items,
  configOptionKeys,
  optionsMeta,
  titleKey,
}) => {
  const packageOptionKeys =
    configOptionKeys?.filter((option) =>
      items.some((item) => item.key === option),
    ) || [];
  const required_options = getAllOptionsPackageRequiredOptions(
    packageOptionKeys,
    items,
  );

  if (!required_options.length) {
    return null;
  }

  return {
    key: ALL_OPTIONS_KEY,
    [titleKey]: `Include all paid options and save ${percent}%`,
    price: 0,
    recommended: false,
    videos_url: "",
    tooltipText: "",
    required_options,
    disabled: optionsMeta?.[ALL_OPTIONS_KEY]?.disabled || false,
    checked: optionsMeta?.[ALL_OPTIONS_KEY]?.checked || false,
    plugin: false,
  };
};

export const normalizeOptionsSelection = (selectedKeys, optionsData) => {
  if (!optionsData?.length) {
    return selectedKeys;
  }

  const allowedKeys = new Set(
    optionsData.filter(isAllowedInSelection).map((item) => item.key),
  );

  let nextSelectedKeys = selectedKeys.filter((key) => allowedKeys.has(key));

  const packageItem = optionsData.find((item) => item.key === ALL_OPTIONS_KEY);
  const requiredOptions = packageItem?.required_options || [];

  if (
    nextSelectedKeys.includes(ALL_OPTIONS_KEY) &&
    !requiredOptions.every((key) => nextSelectedKeys.includes(key))
  ) {
    nextSelectedKeys = nextSelectedKeys.filter((key) => key !== ALL_OPTIONS_KEY);
  }

  return nextSelectedKeys;
};

export const sortOptionsByOrder = (a, b) => {
  if (a.sort_order === 0 && b.sort_order === 0) return 0;
  if (a.sort_order === 0) return -1;
  if (b.sort_order === 0) return 1;
  return a.sort_order - b.sort_order;
};
